<template lang="pug">
v-container(grid-list-md)
  v-layout.menu(wrap)
    v-flex(lg12, md12, xs12)
      v-card.primary--text.subtitle-text.py-2.mb-2.justify-center.text-center(dense) INFORMASI DATA INSTANSI
    v-layout(wrap, justify-center)
      v-flex(lg3, md3, xs12, pa-2, mb-3)
        v-card(@click="routerMenu('GROUP')")
          v-row
            v-icon.ml-6.mr-3(large, color="deep-purple darken-4") mdi-select-group
            v-divider(vertical)
            div
              v-card-title.subtitle-text JUMLAH GROUP
              v-card-subtitle.caption {{ groups.length }} Group
      v-flex(lg3, md3, xs12, pa-2, mb-3)
        v-card(@click="routerMenu('USER')")
          v-row
            v-icon.ml-6.mr-3(large, color="orange accent-4") mdi-account-supervisor-circle
            v-divider(vertical)
            div
              v-card-title.subtitle-text JUMLAH USER
              v-card-subtitle.caption {{ users.length }} User
      v-flex(lg3, md3, xs12, pa-2)
        v-card(@click="routerMenu('ACCOUNT')")
          v-row
            v-icon.ml-6.mr-3(large, color="blue darken-4") mdi-credit-card-multiple-outline
            v-divider(vertical)
            div
              v-card-title.subtitle-text JUMLAH REKENING
              v-card-subtitle.caption {{ listAccount.length }} Rekening
      v-flex(lg3, md3, xs12, pa-2, mb-3)
        v-card(@click="routerMenu('MERCHANT')")
          v-row
            v-icon.ml-6.mr-3(large, color="cyan accent-4") mdi-store
            v-divider(vertical)
            div
              v-card-title.subtitle-text JUMLAH MERCHANT
              v-card-subtitle.caption {{ listMerchant.length }} Merchant

    v-flex(lg12, md12, xs12)
      v-card.primary--text.subtitle-text.py-2.mb-2.justify-center.text-center(dense) REKAP TRANSAKSI DALAM WAKTU 1 BULAN
    v-layout(row, justify-center)
      v-flex(lg3, md3, xs12, pa-2, mb-3)
        v-card(@click="routerMenu('ENTRY')")
          v-row
            v-icon.ml-6.mr-3(large, color="success") mdi-account-edit
            v-divider(vertical)
            div
              v-card-title.subtitle-text MENUNGGU VERIFIKASI
              v-card-subtitle.caption {{ entry.length }} Transaksi
      v-flex(lg3, md3, xs12, pa-2, mb-3)
        v-card(@click="routerMenu('VERIFY')")
          v-row
            v-icon.ml-6.mr-3(large, color="success") mdi-account-check
            v-divider(vertical)
            div
              v-card-title.subtitle-text MENUNGGU APPROVAL
              v-card-subtitle.caption {{ verify.length }} Transaksi
      v-flex(lg3, md3, xs12, pa-2, mb-3)
        v-card(@click="routerMenu('SUCCESS')")
          v-row
            v-icon.ml-6.mr-3(large, color="info") mdi-checkbox-marked-outline
            v-divider(vertical)
            div
              v-card-title.subtitle-text BERHASIL
              v-card-subtitle.caption {{ success.length }} Transaksi
      v-flex(lg3, md3, xs12, pa-2, mb-3)
        v-card(@click="routerMenu('FAILED')")
          v-row
            v-icon.ml-6.mr-3(large, color="error") mdi-close-circle
            v-divider(vertical)
            div
              v-card-title.subtitle-text GAGAL
              v-card-subtitle.caption {{ failed.length }} Transaksi
      v-flex(lg3, md3, xs12, pa-2, mb-3)
        v-card(@click="routerMenu('REJECT')")
          v-row
            v-icon.ml-6.mr-3(large, color="error") mdi-delete-sweep
            v-divider(vertical)
            div
              v-card-title.subtitle-text DITOLAK
              v-card-subtitle.caption {{ reject.length }} Transaksi
      v-flex(lg3, md3, xs12, pa-2, mb-3)
        v-card(@click="routerMenu('SUSPECT')")
          v-row
            v-icon.ml-6.mr-3(large, color="warning") mdi-timer-sand
            v-divider(vertical)
            div
              v-card-title.subtitle-text DALAM PROSES
              v-card-subtitle.caption {{ suspect.length }} Transaksi
    v-flex(lg12, md12, xs12)
      v-card(v-if="listRequest")
        v-card-title.primary--text.subtitle-text(dense) 10 AKTIVITAS TERAKHIR
          v-spacer
          v-icon(color="primary") mdi-check-circle-outline
        v-divider
        v-timeline(align-top, dense)
          v-timeline-item.pr-6(
            v-for="(item, i) in listRequest",
            :key="i",
            :color="getColor(item.status)",
            small
          )
            v-card
              v-layout(row, pl-3, py-2)
                v-flex(lg9, md9, xs12)
                  .caption {{ item.description }}
                v-flex(lg2, md2, xs12)
                  v-chip.my-1.justify-center.text-center.subsubtitle-bold(
                    small,
                    :color="getColor(item.status)",
                    style="width: 100%"
                  ) {{ item.statusName }}
</template>
<script>
export default {
  name: "FDashboardAdminDefault",
  props: ["userDetail"],
  data() {
    return {
      listData: [],
      listUser: [],
      listGroup: [],
      listRequest: [],
      listAccount: [],
      listMerchant: [],
    };
  },
  watch: {
    userDetail(val) {
      this.listAccount = val ? val.corporate.corporateGroup.accounts : [];
      this.listMerchant = val ? val.corporate.corporateGroup.merchants : [];
    },
  },
  mounted() {
    this.doLoad();
  },
  computed: {
    entry() {
      return this.listData.filter((f) => f.status == "ENTRY");
    },
    verify() {
      return this.listData.filter((f) => f.status == "VERIFY");
    },
    success() {
      return this.listData.filter((f) => f.status == "SUCCESS");
    },
    failed() {
      return this.listData.filter((f) => f.status == "FAILED");
    },
    reject() {
      return this.listData.filter((f) => f.status == "REJECT");
    },
    suspect() {
      return this.listData.filter((f) => f.status == "SUSPECT");
    },
    groups() {
      return this.listGroup.filter((f) => f.status != "CLOSED");
    },
    users() {
      return this.listUser.filter((f) => f.status != "CLOSED");
    },
  },
  methods: {
    doLoad() {
      this.$http.get("/api/system/dashboard").then((success) => {
        this.listData = success.data;
      });
      this.$http.get("/api/system/dashboard-admin").then((success) => {
        this.listGroup = success.data.groups;
        this.listUser = success.data.users;
        this.listRequest = success.data.requests;
      });
      this.listAccount = this.userDetail
        ? this.userDetail.corporate.corporateGroup.accounts
        : [];
      this.listMerchant = this.userDetail
        ? this.userDetail.corporate.corporateGroup.merchants
        : [];
    },
    getColor(status) {
      if (status == "ENTRY") {
        return "green accent-1";
      } else if (status == "VERIFY") {
        return "green accent-2";
      } else if (status == "SUSPECT") {
        return "warning";
      } else if (status == "SUCCESS") {
        return "info";
      } else if (status == "REJECT") {
        return "red lighten-3";
      } else if (status == "APPROVED") {
        return "success";
      } else if (status == "NEW") {
        return "warning";
      } else if (status == "AUTOTRX") {
        return "success";
      } else {
        return "error";
      }
    },
    routerMenu(status) {
      if (status) {
        if (status == "GROUP") {
          this.$router
            .push({
              name: "corporate-group",
            })
            .catch((err) => {});
        } else if (status == "USER") {
          this.$router
            .push({
              name: "corporate-spv",
            })
            .catch((err) => {});
        } else if (status == "ACCOUNT") {
          this.$router
            .push({
              name: "access-account-group",
            })
            .catch((err) => {});
        } else if (status == "MERCHANT") {
          this.$router
            .push({
              name: "access-merchant-group",
            })
            .catch((err) => {});
        } else if (status == "ENTRY" && this.roleId == "VRF_USER") {
          this.$router
            .push({
              name: "verify-transaction",
            })
            .catch((err) => {});
        } else if (status == "VERIFY" && this.roleId == "APR_USER") {
          this.$router
            .push({
              name: "approval-transactions",
            })
            .catch((err) => {});
        } else {
          this.$router
            .push({
              name: "report-transaction",
            })
            .catch((err) => {});
        }
      }
    },
  },
};
</script>